export default __webpack_public_path__ + "static/soehne-mono-web-leicht-d2a588e22755fe8b5c76a3a17d340c6d.woff2";